import { render, staticRenderFns } from "./Mockup.vue?vue&type=template&id=3bed77fc&scoped=true&"
import script from "./Mockup.vue?vue&type=script&lang=js&"
export * from "./Mockup.vue?vue&type=script&lang=js&"
import style0 from "./Mockup.vue?vue&type=style&index=0&id=3bed77fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bed77fc",
  null
  
)

export default component.exports